import { BundleProps } from 'utils/types';
import { StyledPipaBundle } from './style';
import { Box } from '@mui/system';
import { EBundlesInternalViewModel } from 'utils/enums';
import { BundlePrice } from 'components/BundlePrice';
import { PipaSaleBadge } from 'components/Badge/Sale/PipaSaleBadge';

export const PipaBundle: React.FC<BundleProps> = ({
  price,
  productList,
  backgroundSrc,
  backgroundColor = { colorOne: '#880000' },
  salePercentage = 0,
  salePercentageDisplayType,
  inMobileMock = false,
}) => {
  return (
    <StyledPipaBundle
      backgroundSrc={backgroundSrc}
      backgroundColor={backgroundColor}
      isPreview={inMobileMock}
    >
      <Box className="container">
        {productList.length > 0 && (
          <Box className="products">
            {salePercentage > 0 && (
              <PipaSaleBadge
                salePercentage={salePercentage}
                salePercentageDisplayType={salePercentageDisplayType}
              />
            )}
            <Box className="main-product">
              <Box className="main-product--image">
                <img
                  src={productList[0].images.product}
                  alt="main-product"
                  className="image"
                />
              </Box>
              <Box className="main-product--amount">
                <span
                  className="main-product--amount__price"
                  style={{ color: productList[0].textFontColorHex || '#FFF' }}
                >
                  {productList[0].quantityDisplay || '100'}
                </span>
                {salePercentage > 0 && (
                  <p className="main-product--amount__stroked">
                    {productList[0].strokedSaleQuantity}
                  </p>
                )}
              </Box>
            </Box>
            {productList.length > 1 && (
              <Box className="container--sub-product">
                {productList.slice(1, 3).map((product, i) => (
                  <Box className="sub-product" key={i}>
                    <Box className="sub-product--image">
                      <img
                        src={product?.images.product}
                        alt="sub-product"
                        className="image"
                      />
                    </Box>
                    <Box className="sub-product--amount">
                      <span
                        className="sub-product--amount__price"
                        style={{
                          color: product?.textFontColorHex || '#FFF',
                        }}
                      >
                        {product?.quantityDisplay}
                      </span>
                    </Box>
                  </Box>
                ))}
              </Box>
            )}
          </Box>
        )}
        <BundlePrice price={price} type={EBundlesInternalViewModel.PIPA} />
      </Box>
    </StyledPipaBundle>
  );
};
